import React from 'react';
import { Reveal } from './Reveal';
import { EmbedForm, FormField } from './EmbedForm';
import { images, repowerSteps } from '../data/site';
const repowerFields: FormField[] = [{
  name: 'name',
  label: 'Name',
  type: 'text',
  required: true,
  autoComplete: 'name'
}, {
  name: 'phone',
  label: 'Phone',
  type: 'tel',
  required: true,
  autoComplete: 'tel'
}, {
  name: 'email',
  label: 'Email',
  type: 'email',
  autoComplete: 'email',
  full: true
}, {
  name: 'boat',
  label: 'Boat year / make / length',
  type: 'text',
  placeholder: 'e.g. 2004 Carolina Skiff, 21 ft'
}, {
  name: 'engine',
  label: 'Current engine',
  type: 'text',
  placeholder: 'e.g. 115 HP 2-stroke'
}, {
  name: 'preference',
  label: 'What you want',
  type: 'choice',
  options: ['Yamaha', 'Honda', 'Not sure']
}, {
  name: 'message',
  label: 'Message',
  type: 'textarea',
  placeholder: 'How you use the boat, timing, anything else'
}];
export function Repower() {
  return <section id="repowers" aria-labelledby="repower-title" className="w-full scroll-mt-24 bg-sand" data-id="element-266" data-mp="kxuelznjf8sb">
      <div className="gutter section-y pb-12 md:pb-16" data-id="element-267" data-mp="303r2y55r6ad9">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-end lg:gap-[6vw]" data-id="element-268" data-mp="351an1lp4thd4">
          <Reveal data-id="element-269" data-mp="3935qavqmi4tj">
            <h2 id="repower-title" className="display text-[clamp(3.25rem,8vw,9.5rem)] font-extrabold text-navy" data-id="element-270" data-mp="392m95h8srkgk">
              Repower Your Boat
            </h2>
          </Reveal>
          <Reveal delay={0.05} data-id="element-271" data-mp="3it7dzmf2dl7x">
            <p className="max-w-[60ch] text-lg leading-relaxed text-ink-muted md:text-xl" data-id="element-272" data-mp="3irvzosnzsv2k">
              Give your hull a second life with a new Yamaha or Honda outboard. We spec the right engine, rig it, and test it before it goes
              back in the water. Honda offers engines from <strong className="text-ink" data-id="element-273" data-mp="nudtzp74buy">2.5 HP to 250 HP</strong>, and most motors are
              available within <strong className="text-ink" data-id="element-274" data-mp="1ydvno3pit6bf">2–4 days</strong>.
            </p>
          </Reveal>
        </div>

        <ol className="mt-14 grid gap-px overflow-hidden rounded-xl bg-navy/15 md:grid-cols-3" data-id="element-275" data-mp="22dxibswu8zh7">
          {repowerSteps.map((s, i) => <li key={s.title} className="relative flex items-start gap-5 bg-sand-50 p-6 md:p-8 3xl:p-10" data-id="element-276" data-mp="35puyylx2roa7" data-mpi={i}>
              <span className="display shrink-0 text-6xl font-extrabold leading-none text-water md:text-7xl" data-id="element-277" data-mp="30smkavb4y2dp">{i + 1}</span>
              <div data-id="element-278" data-mp="3aoxvfhyzom6k">
                <h3 className="display text-2xl font-bold text-navy md:text-[1.7rem]" data-id="element-279" data-mp="3aog1wt3pom2c">{s.title}</h3>
                <p className="mt-2 text-ink-muted" data-id="element-280" data-mp="3onp58s6tjlow">{s.text}</p>
              </div>
            </li>)}
        </ol>
      </div>

      <div className="grid w-full lg:grid-cols-2" data-id="element-281" data-mp="3jounltkl836d">
        <div className="flex flex-col" data-id="element-282" data-mp="29e78xd6dtyd">
          <div className="relative min-h-[420px] flex-1 lg:min-h-[640px]" data-id="element-283" data-mp="28cw6sw5t7gn">
            <img src={images.repowerRigging} alt="Technician rigging a brand-new outboard on the transom of a center console boat in the Soundside Marine shop" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-284" data-mp="3tg8kdtl5movt" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-navy-950/85 to-transparent p-6 pt-24 md:p-10 md:pt-32" data-id="element-285" data-mp="pxb1j7aqipu3">
              <p className="display max-w-[20ch] text-3xl font-bold text-white md:text-4xl" data-id="element-286" data-mp="uukx74opvxqd">Rigged in-house. Tank-tested before launch.</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-px bg-navy-950" data-id="element-287" data-mp="kvvghf8k4jbp">
            {[{
            src: images.beforeOutboard,
            label: 'Before',
            alt: 'Tired, oxidized old outboard on a weathered boat transom before a repower'
          }, {
            src: images.afterOutboard,
            label: 'After',
            alt: 'Brand-new outboard on a clean center console hull after a repower'
          }].map(p => <figure key={p.label} className="relative aspect-[4/3]" data-id="element-288" data-mp="27qhel2uhmj8">
                <img src={p.src} alt={p.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-289" data-mp="3kck0suesudjr" />
                <figcaption className={`absolute left-3 top-3 rounded px-2.5 py-1 text-xs font-bold uppercase tracking-wide ${p.label === 'After' ? 'bg-water text-navy-950' : 'bg-white text-navy-900'}`} data-id="element-290" data-mp="3pb4zuqiber6m">
                  {p.label}
                </figcaption>
              </figure>)}
          </div>
        </div>

        <div id="repower-quote" className="gutter scroll-mt-24 bg-navy py-12 md:py-16 lg:py-20" data-id="element-291" data-mp="33jk8d935bq99">
          <h3 className="display text-4xl font-bold text-white md:text-5xl" data-id="element-292" data-mp="2yjxuqyjeo7zx">Get a Repower Quote</h3>
          <p className="mt-3 max-w-[50ch] text-white/75" data-id="element-293" data-mp="2tle7mut2sq5z">
            Tell us about your boat and we’ll come back with the right Yamaha or Honda for it.
          </p>
          <EmbedForm className="mt-8" embedId="onedash-form-repower" fields={repowerFields} submitLabel="Get My Repower Quote" successTitle="Got it — thanks!" successText="Michael will review your boat details and reach out with a repower recommendation." data-id="element-294" data-mp="2oo48uojsr25h" />
        </div>
      </div>
    </section>;
}